import { render, staticRenderFns } from "./secondPage.vue?vue&type=template&id=72e616b2&"
import script from "./secondPage.vue?vue&type=script&lang=js&"
export * from "./secondPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports